import { DateTimeFormatter, ZonedDateTime } from '@js-joda/core';

import { useQuery } from 'platform/apollo';

import { localDateFromJsDate } from 'shared/helpers/datetime';

import { GetCloseOfEscrowHolidays } from 'buying/graphql/queries';
import { GetCloseOfEscrowHolidays as GetCloseOfEscrowHolidaysQuery } from 'buying/graphql/queries/__generated__/GetCloseOfEscrowHolidays';

const DATE_PATTERN = 'yyyy/MM/dd'; // matches what is returned from graphql
/**
 * Fetch company holidays and return a list of eligible close of escrow LocalDate objects based on the given range
 * and a function for handling datepicker validation
 */
export const useEligibleCloseOfEscrowLocalDates = (
  minNumDaysFromToday: number,
  maxNumDaysFromToday: number,
): [Map<string, boolean>, (day: Date) => boolean] => {
  const { data } = useQuery<GetCloseOfEscrowHolidaysQuery>(GetCloseOfEscrowHolidays, {
    fetchPolicy: 'cache-first',
  });

  const holidays = data?.buyer?.closeOfEscrowHolidays?.dates ?? [];
  const holidaysMap = new Map(holidays.map((dateStr) => [dateStr, true]));

  const closeOfEscrowDateRange = new Map();
  // Iterate over a range of dates
  // Format each date to yyyy/MM/dd format and check if it's a holiday
  // If not a holiday, add to the list of eligible close of escrow dates and convert to LocalDate
  for (let i = minNumDaysFromToday; i <= maxNumDaysFromToday; i++) {
    const includedDate = ZonedDateTime.now()
      .plusDays(i)
      .format(DateTimeFormatter.ofPattern(DATE_PATTERN));
    if (!holidaysMap.has(includedDate)) {
      closeOfEscrowDateRange.set(includedDate.replace(/\//g, '-'), true);
    }
  }

  const handleIsOutOfRange = (date: Date): boolean => {
    return !closeOfEscrowDateRange.has(localDateFromJsDate(date).toString());
  };

  return [closeOfEscrowDateRange, handleIsOutOfRange];
};
